<template>
    <div class="main-view">
        <home-nav class="m-hidden-view"></home-nav>

        <gzh-code-view class="m-hidden-view"></gzh-code-view>
        <div class="center-view">

            <div class="center-body">

                <div class="m-hidden-view" style="display: flex;align-items: center;position: absolute;top: 280px;">
                    <div class="code-view">
                        <img src="../../assets/app_url_code.png" style="width: 105px;height: 105px;">
                        <span style="font-size: 10px;color: #666666;margin-top: 10px;">扫码下载app</span>
                    </div>

                    <div style="margin-left: 50px;">
                        <div @click="goAppDownloadPage" class="download-button">
                            <img src="../../assets/android.png" style="width: 20px;height: 20px;margin-right: 10px;">
                            安卓版下载
                        </div>
                        <div v-if="false" class="download-button" style="margin-top: 20px">
                            <img src="../../assets/iOS.png" style="width: 20px;height: 20px;margin-right: 10px;">
                            苹果版下载
                        </div>
                    </div>

                </div>

                <div class="text-box-info">
                    <div>{{webConfig.appName}}  APP下载</div>
                    <div class="text-second">
                        让快乐，在这里汇合
                    </div>
                </div>

                <div class="tel-view">
                    <img src="../../assets/app-index.png" style="width: 100%;height: 100%;">
                </div>

                <div class="button-pc-view">
                    <div @click="goAppDownloadPage" class="button-pc">
                        立即下载
                    </div>
                </div>

            </div>


        </div>

        <home-footer class="m-hidden-view"></home-footer>
    </div>
</template>

<script>
    import homeNav from "@/components/home/HomeNav";
    import homeFooter from "@/components/home/HomeFooter";
    import gzhCodeView from "@/components/home/GzhCodeView";
    import webConfig from "@/api/config";

    export default {
        name: "HomeDownloadApp",
        components: {
            homeNav,
            homeFooter,
            gzhCodeView,
        },
        data() {
            return {
                webConfig: {},
                appUrl: 'https://oss.huiwanyx.com/hujtqmfz/1/%E6%B1%87%E7%8E%A9%E6%B8%B8%E6%88%8F.apk',
            }
        },
        mounted() {
            this.webConfig = webConfig;
        },
        methods: {
            goAppDownloadPage() {
                window.open(this.appUrl, '_blank')
            }
        }
    }
</script>

<style scoped>
    .main-view {
        width: 100%;
        height: 100vh;
        overflow-y: scroll;
        overflow-x: hidden;
        background-color: #eaeef3;
        position: relative;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }
    .center-view {
        display: flex;
        width: 100%;
        height: calc(100vh - 80px);
        justify-content: space-between;
        background-image: url(../../assets/all-background.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .tel-view {
        width:280px;
        height: 550px;
        background-color: #ffffff;
        border-radius: 25px;
        position: absolute;
        right: 15px;
        overflow: hidden;
    }
    .download-button {
        width: 180px;
        height: 50px;
        border-radius: 40px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        padding: 0 25px;
        box-sizing: border-box;
        color: #444444;
        user-select: none;
        cursor: pointer;
    }
    .code-view {
        width: 125px;
        height: 145px;
        background-color: #ffffff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .text-box-info {
        font-size: 50px;
        color: #f64e7a;
        font-weight: bold;
        position: absolute;
        top: 40px;
        text-align: left
    }
    .text-second {
        font-size: 30px;
        margin-top: 20px;
    }
    .button-pc-view {
        display: none;
    }
    .center-body {
        width: 100%;
        max-width: 900px;
        margin: 50px auto 0;
        position: relative
    }
    @media screen and (max-width: 900px) {
        .m-hidden-view {
            display: none !important;
        }
        .center-view {
            height: 100vh;
            background-image: url(../../assets/app-background.png);
        }
        .center-body {
            margin: 0;
            padding-bottom: 80px;
            overflow-y: auto;
        }
        .text-box-info {
            position: unset;
            font-size: 25px;
            text-align: left;
            margin-left: 20px;
            margin-top: 40px;
        }
        .text-second {
            font-size: 16px;
            margin-top: 15px;
        }
        .tel-view {
            position: unset;
            margin: 50px auto 0;
        }
        .button-pc-view {
            position: fixed;
            bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }
        .button-pc {
            width: 200px;
            height: 40px;
            border-radius: 40px;
            background-color: #ef4848;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: bold;
            box-sizing: border-box;
            color: #ffffff;
            user-select: none;
            cursor: pointer;

        }
    }

</style>